import { render, staticRenderFns } from "./salesReturnDetail.vue?vue&type=template&id=50058038&scoped=true"
import script from "./salesReturnDetail.vue?vue&type=script&lang=js"
export * from "./salesReturnDetail.vue?vue&type=script&lang=js"
import style0 from "./salesReturnDetail.vue?vue&type=style&index=0&id=50058038&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50058038",
  null
  
)

export default component.exports